<template>
	<div :key="postKey">

		<v-btn v-if="newPostsCount > 0 && !refreshing" @click="!isTop ? scroll() : getPosts()" class="scroll-to-top" :loading="refreshing">
			<v-icon v-if="!isTop">mdi-arrow-up</v-icon>
			<v-icon v-else>mdi-sync</v-icon>
			<template>Nowe posty ({{ newPostsCount }})</template>
		</v-btn>
		<!--		<post pinned />-->
		<div class="d-flex align-center mb-6">
			<v-divider class="flex-grow-1 flex-shrink-1 mr-3" />
			<little-select
				:value="sortBy"
				@selected="filterSelected"
				class="flex-grow-0 flex-shrink-1"
			/>
		</div>
		<div id="posts-begining" v-intersect="{
			handler: beginingIntersecting,
			options: {
				threshold: [0.5]
			}
		}" />
		<div v-if="posts.length">
			<v-lazy
				v-for="(item, index) in posts"
				:key="`post-${item.id}- ${index}`"
				v-model="isActive[index]"
				:options="{ threshold: 0 }"
				:transition="null"
				min-height="100"
			>
				<div
					v-if="
						index == posts.length - 2 &&
						typeof isActive[index] !== 'undefined'
					"
					v-intersect="infiniteScrolling"
				/>
				<post
					:key="`${item.id}-${index}-${session}`"
					:post="item"
					:id="`wall-post__${item.id}`"
					@seen="postSeen"
				/>
			</v-lazy>
		</div>
		<div v-if="loading">
			<v-card
				v-for="i in skeletons"
				:key="i"
				flat
				outlined
				class="wall-card"
			>
				<v-card-text>
					<v-skeleton-loader
						:type="
							i % 2 == 0
								? 'image, article, actions'
								: 'article, action'
						"
					></v-skeleton-loader>
				</v-card-text>
			</v-card>
			<div class="text-center text-muted">
				<v-progress-circular
					indeterminate
					size="34"
					color="$light-muted"
				></v-progress-circular>
				Wczytywanie
			</div>
		</div>
		<div
			v-if="
				posts.length && meta.last_page == meta.current_page && !loading
			"
			class="text-center text-muted"
		>
			Nie ma więcej postów
		</div>
	</div>
</template>

<script>
import LittleSelect from "@/components/items/LittleSelect";
import Post from "@/components/wall/post/Post";
import { mapGetters } from "vuex";
import _ from "lodash";
import axios from "axios";
export default {
	name: "Posts",
	components: {
		Post,
		LittleSelect,
	},
	data() {
		return {
			// top, new, old, or activity.
			isActive: [true],
			// loading: true,
			postKey: 0,
			seenPostsToSend: [],
			refreshing: false
		};
	},
	computed: {
		...mapGetters({
			loading: "wall/loading",
			posts: "wall/posts",
			meta: "wall/meta",
			sortBy: "wall/sortBy",
			seenPosts: "wall/seenPosts",
			lastBunch: "wall/lastBunch",
			session: "wall/session",
			currentVisiblePost: "wall/currentVisiblePost",
			newPostsCount: "wall/newPostsCount",
			isTop: "wall/isTop"
		}),
		skeletons() {
			if (this.posts && this.posts.length) {
				return 2;
			}
			return 5;
		},
	},

	methods: {
		scroll() {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		},
		beginingIntersecting(entries, observer, isIntersecting) {
			if(!this.isTop && isIntersecting && this.newPostsCount > 0 && !this.isTop) {
				this.getPosts();
			}
			this.$store.commit('wall/setIsTop', isIntersecting)
		},
		postSeen(id) {
			if (
				this.seenPostsToSend.indexOf(id) === -1 &&
				this.seenPosts.indexOf(id) === -1
			) {
				this.seenPostsToSend.push(id);
			}
			this.sendSeenPosts();
			this.$store.commit("wall/addSeenPost", id);
			this.$store.commit('wall/setCurrentVisiblePost', id);
		},
		async sendSeenPosts() {
			if (this.seenPostsToSend.length) {
				// AXIOS SEND!
				await axios
					.post("post-user-watched", {
						post_ids: this.seenPostsToSend,
					})
					.then(() => {
						this.seenPostsToSend = [];
					})
					.catch((error) => {
						console.log("Error sending seen posts", error);
					});
			}
		},
		infiniteScrolling(entries, observer, isIntersecting) {
			if (isIntersecting) {
				if (this.meta.current_page < this.meta.last_page) {
					if (!this.loading) {
						this.getPosts({ page: this.meta.current_page + 1 });
					} else {
						this.getPosts({ page: this.meta.current_page + 1 });
					}
				}
			}
		},
		async getPosts(params) {
			if (!params) {
				this.refreshing = true;
				this.$store.commit("wall/clearPosts");
			}
			await this.$store.dispatch("wall/getPosts", params);
			this.refreshing = false;
		},
		async filterSelected(value) {
			this.$store.commit("wall/setSortBy", value);
			await this.getPosts();
		},
		scrolled(e) {
			console.log("SCROLLED", e);
		},
		postUpdated(e) {
			console.log("UPDATED POST IN EVENT!", e)
		}
	},
	beforeDestroy() {
		this.$store.commit("wall/clearPosts");
		this.isActive = [true];
	},
	mounted() {
		this.$store.commit("wall/incrementSession");
		this.getPosts = _.debounce(this.getPosts, 300);
		this.sendSeenPosts = _.debounce(this.sendSeenPosts, 1500);

		if (!this.posts.length) {
			this.getPosts(null);
		}
	},
};
</script>

<style lang="scss" scoped>

	.scroll-to-top {
		position: fixed;
		width: 140px;
		top: 100px;
		left: calc(50vw - 70px);
		z-index: 99;
	}
</style>
